import React from "react";
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer";
import './contact_style.css'
// import {Helmet} from "react-helmet";


import { Link } from "react-router-dom";
const Launch = ()=> {

    return (
        <>
          <AIheader/>
            <section className="contactPageMain" id="">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        {/* START Left Section */}
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="contactPageLeft">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/contact-us">Rentid Launch</Link></li>
                                </ol>
                            </nav>
                            <h2>Rentid Launch</h2>
                                <form-widget ucid='1YpCtrfhAfErgPgbFKOkIWrTb8s'></form-widget>
                            </div>
                        </div>
                        {/* END Left Section */}

                        {/* START Right Section */}
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="contactPageRight">
                                <div className="contactPageRightInner">
                                    <h2>We’re here to help.</h2>
                                    <p>Workflows and tools built to help your rental business thrive. Let us know how we can assist you.</p>
                                </div>
                                
                                <div className='contactLogoOuter'>
                                    <div className="contactLogoInner contactLogoGreen">
                                        <a href="/rentdirect" alt="Go to Rent Direct">
                                        <div className="green_overlay"></div>
                                            <figure><img src="/img/rent_direct_logo.png" alt="Rent Direct logo"/></figure>
                                        </a>
                                    </div>
                                    
                                    <div className="contactLogoInner contactLogoSky">
                                        <a href="/rentid" alt="Go to Rent ID">
                                            <div className="sky_overlay"></div>
                                            <figure> <img src="/img/rent_id_logo.svg" alt="Rent ID logo"/></figure>
                                        </a>
                                    </div>

                                    <div className="contactLogoInner contactLogoRed">
                                        <a href="/rentshield" alt="Go to Rent Shield">
                                            <div className="red_overlay"></div>
                                            <figure><img src="/img/rent_shield_logo.png" alt="Rent Shield logo"/></figure>
                                        </a>
                                    </div>
            
                                    <div className="contactLogoInner contactLogoPurple">
                                        <a href="/rentsuccess" alt="Go to Rent Success">
                                            <div className="purple_overlay"></div>
                                            <figure><img src="/img/rent_success_logo.png" alt="Rent Success logo"/></figure>
                                        </a>
                                    </div>


                                    <div className="contactLogoInner contactLogowhite">
                                        <a href="/rentai" alt="Go to Rent AI">
                                            <div className="white_overlay"></div>
                                            <figure> <img src="/img/rent_ai_logo.svg" alt="Rent AI logo"/></figure>
                                        </a>
                                    </div>
                                    <div className="contactLogoInner contactLogoYellow">
                                        <a href="/rentacademy" alt="Go to Rent Academy">
                                            <div className="yellow_overlay"></div>
                                            <figure> <img src="/img/rent_academy_logo.png" alt="Rent Academy logo"/></figure>
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* END Right Section */}
                    </div>
                </div>
            </section>
        <Footer/>
        </>
    )
}
export default Launch;